import React from 'react'
import ASelect from 'react-select/async'
import debounce from 'lodash-es/debounce'
import getStyles from './Select/styles.js'
import Label from './Input/Label'

export const loadOptions = async (self, searchText) => {
  if (!searchText || !searchText.length) {
    searchText = self.props.data || self.props.value || ''
  }
  let loadOpts = self.props.loadOptions
  if (!loadOpts && self.props.ctx && self.props.ctx.lookupRecords && self.props.referenceData) {
    loadOpts = self.props.ctx.lookupRecords
  }

  let options = []
  try {
    options = await loadOpts(searchText, self.props.referenceData)
    self.setState({ options })
  } catch (e) {
    console.error(e)
    options = []
  }
  return options
}

export const getValue = (data, selected) => {
  let { record, fieldPath, referenceData } = data
  if (record && record.$ && record.$.toValueLabel && fieldPath) {
    return record.$.toValueLabel(fieldPath, record, referenceData, selected)
  }
}

export class Input extends React.Component {
  state = { options: [], selectedValue: null }

  onKeyDown = (e) => {
    if (e.keyCode === 13 && this.select && this.select.select && this.select.select && this.select.select.select && this.select.select.select.menuListRef) {
      e.stopPropagation()
    }
  }

  getRef = ref => this.select = ref

  onChange = (v) => {
    let { onChange, onValueChange } = this.props
    onChange && onChange(v)
    this.setState({ selectedValue: v })
    onValueChange && onValueChange(v && v.value)
  }

  dLoadOptions = debounce((searchText, callback) => {
    loadOptions(this, searchText).then(callback)
  }, 300)

  render () {
    // this is needed to deal with react-select's async internal state shit.
    // value comes from the record. if one is selected (known via this.props.data) but not yet persisted to the record,
    // set to undefined so that it uses react-select internal state
    const _value = getValue(this.props, this.state.selectedValue)
    let value
    if (_value) {
      value = _value
    } else {
      value = this.props.data ? undefined : ''
    }
    // const value = getValue(this.props) || this.props.data ? undefined : ''
    return (
      <div className={`w-100 input-wrapper`}>
        <Label {...this.props} />
        <ASelect
          ref={this.getRef}
          onKeyDown={this.onKeyDown}
          {...this.props}
          value={value}
          className={`input ${(this.props.required && !value && `is-invalid`) || ''}`}
          cacheOptions
          loadOptions={this.dLoadOptions}
          onChange={this.onChange}
          isClearable
          menuPortalTarget={document.body}
          components={{
            ...!this.props.icon && { DropdownIndicator: () => null },
            IndicatorSeparator: () => null
          }}
          placeholder={this.props.placeholder || ''}
          styles={getStyles(this.props)}
          classNamePrefix={`react-select`}
          menuPlacement={`auto`}
        />
      </div>
    )
  }
}

export class Output extends React.Component {
  render () {
    let val = getValue(this.props)
    return <span>{val && val.label ? val.label : ''}</span>
  }
}
